import { action, observable } from 'mobx'
import { sample } from 'lodash-es'
import { ModalViewModel } from '@/infra/ModalViewModel'

const messages = [
  'Looks like someone beat you to it!',
  'Oooh you almost had it! You gotta be quicker than that!',
  'Oh no! Somebody swooped in and took this opportunity from right under your nose!',
]

/**
 * View model for the dialog shown when an opportunity was taken by someone
 * else.
 */
export class VanishedDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor message = messages[0]

  /**
   * Shows the dialog with a random message.
   */
  @action.bound
  show() {
    this.message = sample(messages) ?? messages[0]
    this.modal.show()
  }
}
